import styled from 'styled-components';

export const Router = styled.div``;

export default { Router };
